// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tw-color-readout_readout_X60cg {
  width: 28px;
  height: 16px;
  text-align: center;
  -moz-appearance: textfield;
  font: inherit;
  font-weight: bold;
}
[dir='ltr'] .tw-color-readout_readout_X60cg {
  margin-left: 10px;
}
[dir='rtl'] .tw-color-readout_readout_X60cg {
  margin-right: 10px;
}
.tw-color-readout_readout_X60cg::-webkit-outer-spin-button,
.tw-color-readout_readout_X60cg::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/tw-color-readout/tw-color-readout.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX","sourcesContent":[".readout {\n  width: 28px;\n  height: 16px;\n  text-align: center;\n  -moz-appearance: textfield;\n  font: inherit;\n  font-weight: bold;\n}\n[dir='ltr'] .readout {\n  margin-left: 10px;\n}\n[dir='rtl'] .readout {\n  margin-right: 10px;\n}\n.readout::-webkit-outer-spin-button,\n.readout::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"readout": `tw-color-readout_readout_X60cg`
};
export default ___CSS_LOADER_EXPORT___;
